// @flow
import styled from "styled-components"
import { mq } from "common/mediaQuery"
import { Wrap } from "componentsStyled/Layout/Wrap"

export const DetailWrap = styled(Wrap)`
  ${mq.tabletWide} {
    max-width: 40rem;
    margin: 0 auto;
    padding: 0;
    border: 0;
  }
`

export const SectionHeading = styled.div`
  font-size: 1.4rem;
  color: ${(props) => props.theme.color.secondaryText};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
`;



// WEBPACK FOOTER //
// ./src/pages/Product/Detail/styled.js